import { render, staticRenderFns } from "./Serialized-Inventory.vue?vue&type=template&id=a88a6278"
import script from "./Serialized-Inventory.vue?vue&type=script&lang=js"
export * from "./Serialized-Inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports